export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'NVSTech'
